<template>
  <div class="main_body">
    <div id="top_header">
      <p id="top_text">創探科技有限公司</p>
    </div>
    <div class="section_base_block">
      <h3>公司介紹</h3>
      <div class="section_content">
        <p id="company_des">
          創探科技有限公司（簡稱創探科技）成立於2026年，公司位於中國香港，致力於為企事業單位提供網站建設及電子商務應用與推廣服務，包括網路行銷策劃、網路推廣、網頁設計、網站建設、網站維護、網路廣告、平面設計、系統開發、軟體開發與銷售等，幫助各類企業及商戶解決招商推廣與網站維護的難題。公司同時也為商業合作夥伴提供多方面的服務，包括：精準的目標消費群體定位分析、直接的產品與服務平台、最有效的市場行銷效果推廣以及客戶關係管理。</p>
      </div>
    </div>
    <div class="section_gray_block section_base_block">
      <h3>行業優勢</h3>
      <div class="section_content" id="section_adv_content">
        <img id="section_adv_img" src="../../static/img/section_advantage.png" alt="">
        <div id="section_adv_des">
          <p>一、豐富的行動端與網站軟體開發經驗</p>
          <p>業精於專，設計與技術實力雄厚，多年經驗鑄造品質保證。</p>
          <p>二、完善的客戶品質控制流程</p>
          <p>嚴謹的專案管理，保質、保期，每一步您都會很滿意。</p>
          <p>三、快速、即時的售後服務</p>
          <p>快速響應客戶需求，即時處理問題，故障少，問題少。</p>
        </div>
      </div>
    </div>
    <div class="section_base_block">
      <h3>企業文化</h3>
      <div class="section_content" id="section_cul_content">
        <div id="section_clu_des">
          <p>創新</p>
          <p>不斷創新、不斷超越，成就卓越的未來。</p>
          <p>探索</p>
          <p>積極探索、破解未知、運用高效技術。</p>
          <p>誠信</p>
          <p>誠信做人、用心做事、任何事言而有信。</p>
          <p>務實</p>
          <p>腳踏實地、求真務實、積極面對所有事。</p>
        </div>
        <img id="section_clu_img" src="../../static/img/section_culture.png" alt="">
      </div>
    </div>
    <div class="section_gray_block section_base_block">
      <h3>解決方案</h3>
      <div class="section_content" id="section_plan_content">
        <img id="section_plan_img" src="../../static/img/section_plan.png" alt="">
        <div id="section_plan_des">
          <p>1. 互聯網技術研究與應用</p>
          <p>2. IT 技術服務</p>
          <p>3. 計算機軟體開發與應用</p>
          <p>4. 電子商務平台／電子政務平台／門戶網站建設</p>
          <p>5. 提供資訊化解決方案</p>
        </div>
      </div>
    </div>
    <div id="bottom_footer">
      <p id="bottom_copyright">版權所有 © 2026 創探科技有限公司</p>
      <p id="bottom_icp" @click="openGovernment">innexp.com</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainPage',
  data() {
    return {
      msg: 'Welcome to Chuang Tan Tech!'
    };
  },
  methods: {
    openGovernment() {
      window.open("https://innexp.com/", '_blank');
    }
  },
  mounted() {
    document.querySelector('body').setAttribute('style', 'background-color:#FFFFFF !important');
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style');
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#top_header {
  background: url("../../static/img/top_banner.png");
  width: 100%;
  min-width: 1100px;
  height: 600px;
}

#top_text {
  width: 100%;
  border: 0 solid red;
  text-align: center;
  line-height: 34px;
  font-size: 34px;
  color: #000000;
  padding-top: 270px;
}

h3 {
  color: #000000;
  text-align: center;
  font-size: 38px;
}

.section_content {
  width: 1100px;
  margin: 0 auto;
}

p {
  font-size: 18px;
  color: #707070;
  text-align: left;
  text-indent: 0;
}

#company_des {
  margin-top: 30px;
  text-indent: 36px;
  padding-left: 30px;
  padding-right: 30px;
}

.section_gray_block {
  background-color: #FCFCFC;
}

.section_base_block {
  padding-top: 80px;
  padding-bottom: 80px;
  min-width: 1100px;
}

#section_adv_content {
  margin-top: 30px;
  height: 388px;
}

#section_adv_img {
  display: inline-block;
}

#section_adv_des {
  display: inline-block;
  vertical-align: top;
  margin-top: 116px;
  margin-left: 40px;
}

#section_cul_content {
  margin-top: 30px;
  height: 283px;
}

#section_clu_des {
  display: inline-block;
  vertical-align: top;
  margin-top: 37px;
  margin-right: 180px;
}

#section_clu_img {
  display: inline-block;
}

#section_plan_content {
  margin-top: 30px;
}

#section_plan_img {
  display: inline-block;
}

#section_plan_des {
  vertical-align: top;
  display: inline-block;
  margin-top: 120px;
  margin-left: 120px;
}

#bottom_footer {
  background-color: #363636;
  padding-top: 110px;
  padding-bottom: 110px;
  min-width: 1100px;
}

#bottom_copyright {
  font-size: 16px;
  line-height: 16px;
  color: #707070;
  text-align: center;
  text-indent: 0;
}

#bottom_icp {
  font-size: 15px;
  line-height: 15px;
  color: #707070;
  text-align: center;
  text-indent: 0;
  margin-top: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue